import React from 'react';
import PropTypes from 'prop-types';

const HeaderBottom = ({ children }) => <div className="c-header__bottom">{children}</div>

export default HeaderBottom;

HeaderBottom.propTypes = {
  children: PropTypes.node.isRequired,
};
